// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__2OwAt","error":"InputSecondary_error__1gTGN","disabled":"InputSecondary_disabled__3LMul"};